import config from '../../config'
import { buildGetQuery } from '../../util'

import { IGetRequestObject, ITrainingTypeRef } from '../../interfaces'
import qs from 'qs'
import { QueryObserverOptions } from '@tanstack/react-query'

type QueryObject = {
  trainingCategoryId?: number
  activeOnly?: boolean
}

const getTrainingTypesRequest = (
  params: undefined,
  queryObject: QueryObject | undefined,
): IGetRequestObject => {
  const queryString = qs.stringify(queryObject, { addQueryPrefix: true })

  return {
    method: 'get',
    url: `${config.baseUrl}/TrainingTypes/ddl${queryString}`,
  }
}

const useTrainingTypesQueryBase = buildGetQuery<
  undefined,
  QueryObject | undefined,
  ITrainingTypeRef[] | undefined
>({
  getRequest: getTrainingTypesRequest,
  getQueryKey: (params, queryObject) => [
    'training-types',
    queryObject?.activeOnly,
  ],
})

const useTrainingTypesQuery = (
  queryObject?: QueryObject,
  options?: QueryObserverOptions<ITrainingTypeRef[] | undefined, Error>,
) => {
  const trainingTypesQuery = useTrainingTypesQueryBase(undefined, queryObject, options)

  return { ...trainingTypesQuery }
}
export default useTrainingTypesQuery

